<div class="error__wrap" [ngClass]="{ 'error__wrap-active': message }">
  <span class="error-message">{{ message }}</span>
  <button class="error-btn">{{ action }}</button>
</div>
